module.exports = __webpack_public_path__ + "static/img/home-logo-wulian.5543c7eb.jpg";